export default "__VITE_ASSET__CGBAFI4K__"